/**
 * QuotaSummary 组件
 *
 * 显示搜索配额使用总览，按供应商聚合配额信息。
 */

import React from 'react';
import { QuotaProgress } from '../shared';
import type { SearchQuotaItem } from '../../../services/searchAdminApi';

interface QuotaSummaryProps {
  quotaData: Record<string, Record<string, SearchQuotaItem[]>> | null;
  loading: boolean;
}

const quotaTypeLabels: Record<string, string> = {
  concurrency: '并发',
  requests_per_minute: 'RPM',
  requests_per_hour: '每小时',
  requests_per_day: '每日',
  requests_per_month: '每月',
  requests_total: '总计',
};

export const QuotaSummary: React.FC<QuotaSummaryProps> = ({
  quotaData,
  loading,
}) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className="animate-pulse space-y-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-4 bg-gray-200 rounded" />
          ))}
        </div>
      </div>
    );
  }

  if (!quotaData || Object.keys(quotaData).length === 0) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-6 text-center text-gray-500">
        暂无配额数据
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {Object.entries(quotaData).map(([providerName, keys]) => (
        <div
          key={providerName}
          className="bg-white rounded-lg border border-gray-200 p-4"
        >
          <h3 className="text-sm font-medium text-gray-700 mb-3">
            {providerName}
          </h3>
          {Object.entries(keys).map(([keyIndex, quotas]) => (
            <div key={keyIndex} className="mb-3 last:mb-0">
              <div className="text-xs text-gray-500 mb-1">
                密钥 #{keyIndex}
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                {quotas.map((q) => (
                  <QuotaProgress
                    key={`${q.quota_type}-${q.key_index}`}
                    quota={{
                      used: q.used,
                      total: q.limit,
                    }}
                    label={quotaTypeLabels[q.quota_type] || q.quota_type}
                    size="sm"
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default QuotaSummary;
